import React from "react";

// react-bootstrap components
import {
  Button,
  Card,
  Container,
  Dropdown,
  Row,
  Col,
  Tab,
  InputGroup,
  Modal,
  Form,
  OverlayTrigger,
  Tooltip,
  Table,
  Image,
  FormGroup,
} from "react-bootstrap";
import Swal from "sweetalert2";
import Select from "react-select";
// core components
import ReactTable from "components/ReactTable/ReactTable.js";
import CurrencyInput from "react-currency-input-field";
import DataTable from "react-data-table-component";
import {
  getAllSimpanan,
  getRekapSimpananBulanan,
  getDetailSimpanan,
  tambahSimpanan,
  getUserAktifSimpanan,
  updateAllSimpanan,
  exportAllSimpananExsist,
  exportSimpananByDate,
  downloadTemplateHistorySimpanan,
  importHistorySimpanan,
  generateWeeklyHistorySimpanan,
} from "../../stores";
import DetailSimpanan from "./DetailSimpanan";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ReactDatetime from "react-datetime";
import moment from "moment";
import { setConstantValue } from "typescript";
import { CardBody } from "reactstrap";
import { Dna } from "react-loader-spinner";
import ReactPaginate from "react-paginate";
import "./Pagination.css";

function Simpanan() {
  const dispatch = useDispatch();
  const date = new Date();
  const modalDetailSimpanan = useSelector((state) => state.simpananReducer);
  const simpanan = useSelector((state) => state.simpananReducer);
  const auth = useSelector((state) => state.authReducer);
  const [searchText, setSearchText] = React.useState("");
  const [jenisUserFilter, setJenisUserFilter] = React.useState("");
  const [rekapBulan, setRekapBulan] = React.useState(moment().format("YYYY-MM"));
  const [rekapSimpanan, setRekapSimpanan] = React.useState([]);
  const [rekapTotal, setRekapTotal] = React.useState(0);
  const [rekapTotalHistory, setRekapTotalHistory] = React.useState(0);
  const [isLoadingRekap, setIsLoadingRekap] = React.useState(false);
  const [modalTambahSimpanan, setModalTambahSimpanan] = React.useState(false);
  const [modalUpdateSimpanan, setModalUpdateSimpanan] = React.useState(false);
  const [modalExportSimpanan, setModalExportSimpanan] = React.useState(false);
  const [modalImportHistorySimpanan, setModalImportHistorySimpanan] =
    React.useState(false);
  const [modalGenerateWeeklyHistory, setModalGenerateWeeklyHistory] =
    React.useState(false);
  const [nominal, setNominal] = React.useState("");
  const [tglSimpanan, setTglSimpanan] = React.useState("");
  const [tglUpdateSimpanan, setTglUpdateSimpanan] = React.useState("");
  const [tglAddSimpanan, setTglAddSimpanan] = React.useState("");
  const [exportTglMulai, setExportTglMulai] = React.useState("");
  const [exportTglAkhir, setExportTglAkhir] = React.useState("");
  const [tglAkhirGenerateWeekly, setTglAkhirGenerateWeekly] =
    React.useState("");
  const [listAllSimpanan, setListAllSimpanan] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [multipleSelect, setMultipleSelect] = React.useState([]);
  const [userAktifOptions, setUserAktifOptions] = React.useState([]);
  const [excel, setExcel] = React.useState([]);
  const [excelHistorySimpanan, setExcelHistorySimpanan] = React.useState([]);
  const [kirimFcm, setKirimFcm] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };
  const [detailUser, setDetailUser] = React.useState(null);

  moment.locale("id");
  const formatDate = (dateString) => {
    const options = { month: "long", year: "numeric" };
    const formattedDate = new Date(dateString).toLocaleDateString(
      "id-ID",
      options,
    );
    return formattedDate;
  };

  const formatDateFull = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("DD MMMM YYYY");
  };

  const formatPeriodeSimpanan = (row) => {
    if (!row.periodeSimpananStart) {
      return !row.startOfMonth ? "-" : moment(row.startOfMonth).format("MMMM YYYY");
    }

    if (row.jenisUser === "mingguan") {
      return moment(row.periodeSimpananStart).format("dddd, DD MMMM YYYY");
    }

    return moment(row.periodeSimpananStart).format("MMMM YYYY");
  };

  function handleFileChange(e) {
    const selectedFiles = Array.from(e.target.files);
    setExcel(selectedFiles);
  }

  const removeExcel = (index) => {
    setExcel(excel.filter((_, i) => i !== index));
  };

  const handleHistorySimpananFileChange = (e) => {
    setExcelHistorySimpanan(Array.from(e.target.files));
  };

  const removeHistorySimpananExcel = (index) => {
    setExcelHistorySimpanan(excelHistorySimpanan.filter((_, i) => i !== index));
  };

  const escapeHtml = (value) =>
    String(value === undefined || value === null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

  const renderImportHistorySimpananRows = (rows, emptyText) => {
    if (!rows || rows.length === 0) {
      return `<div style="padding:10px;color:#64748b;">${emptyText}</div>`;
    }

    return `
      <div style="max-height:260px;overflow:auto;border:1px solid #e5e7eb;border-radius:8px;margin-top:8px;">
        <table style="width:100%;border-collapse:collapse;font-size:12px;text-align:left;">
          <thead>
            <tr style="background:#f8fafc;color:#334155;">
              <th style="padding:8px;border-bottom:1px solid #e5e7eb;">Baris</th>
              <th style="padding:8px;border-bottom:1px solid #e5e7eb;">Nopeg</th>
              <th style="padding:8px;border-bottom:1px solid #e5e7eb;">Tanggal</th>
              <th style="padding:8px;border-bottom:1px solid #e5e7eb;">Nominal</th>
              <th style="padding:8px;border-bottom:1px solid #e5e7eb;">Alasan</th>
            </tr>
          </thead>
          <tbody>
            ${rows
              .map(
                (row) => `
                  <tr>
                    <td style="padding:8px;border-bottom:1px solid #f1f5f9;">${escapeHtml(row.row || "-")}</td>
                    <td style="padding:8px;border-bottom:1px solid #f1f5f9;">${escapeHtml(row.nopeg || "-")}</td>
                    <td style="padding:8px;border-bottom:1px solid #f1f5f9;">${escapeHtml(row.tglSimpanan || "-")}</td>
                    <td style="padding:8px;border-bottom:1px solid #f1f5f9;">${escapeHtml(row.nominal || 0)}</td>
                    <td style="padding:8px;border-bottom:1px solid #f1f5f9;color:#b91c1c;font-weight:600;">${escapeHtml(row.message || row.reason || "-")}</td>
                  </tr>
                `,
              )
              .join("")}
          </tbody>
        </table>
      </div>
    `;
  };

  const showImportHistorySimpananResult = (responseData, fallbackIcon = "success") => {
    const gagal = responseData?.gagal || [];
    const sudahAda = responseData?.sudahAda || [];
    const hasGagal = gagal.length > 0;
    const hasSudahAda = sudahAda.length > 0;

    Swal.fire({
      icon: hasGagal ? "warning" : fallbackIcon,
      title: hasGagal ? "Import selesai dengan catatan" : "Import selesai",
      width: 900,
      html: `
        <div style="text-align:left;">
          <p style="margin-bottom:10px;">${escapeHtml(responseData?.message || "Import histori simpanan selesai.")}</p>
          <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px;">
            <span style="background:#dcfce7;color:#166534;padding:6px 10px;border-radius:6px;font-weight:700;">Dibuat: ${escapeHtml(responseData?.totalDibuat || 0)}</span>
            <span style="background:#fef3c7;color:#92400e;padding:6px 10px;border-radius:6px;font-weight:700;">Sudah ada: ${escapeHtml(responseData?.totalSudahAda || 0)}</span>
            <span style="background:#fee2e2;color:#991b1b;padding:6px 10px;border-radius:6px;font-weight:700;">Gagal: ${escapeHtml(responseData?.totalGagal || 0)}</span>
          </div>
          <h6 style="font-weight:800;margin:12px 0 0;">Data gagal</h6>
          ${renderImportHistorySimpananRows(gagal, "Tidak ada data gagal.")}
          ${
            hasSudahAda
              ? `<h6 style="font-weight:800;margin:16px 0 0;">Data dilewati karena sudah ada</h6>${renderImportHistorySimpananRows(
                  sudahAda,
                  "Tidak ada data yang dilewati.",
                )}`
              : ""
          }
        </div>
      `,
    });
  };

  const handleFilterChange = () => {
    setIsLoading(true);
    setPage(0);
    getAllSimpanan(dispatch, {
      page: 1,
      limit: totalPerHalaman,
      cari: searchText,
      jenisUser: jenisUserFilter,
    })
      .then((response) => {
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      // Panggil fungsi pencarian di sini
      handleFilterChange();
    }
  };

  function submitTambahSimpanan(e) {
    e.preventDefault();

    if (tglSimpanan === "") {
      Swal.fire({
        title: "Tanggal Simpanan harus diisi !",
        icon: "warning",
      });
      return;
    }

    if (excel.length === 0) {
      Swal.fire({
        title: "Pilih file terlebih dahulu !",
        icon: "warning",
      });
      return;
    }

    Swal.fire({
      title: "Loading ...",
      didOpen() {
        Swal.showLoading();
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
    });
    const formData = new FormData();
    formData.append("tglSimpanan", tglSimpanan);
    excel.forEach((file) => {
      formData.append("excelFile", file);
    });

    tambahSimpanan(formData)
      .then((response) => {
        if (response.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            // timer: 1500,
            showConfirmButton: true,
          });
          setModalTambahSimpanan(false);
          setTglSimpanan(""); // Assuming tglSimpanan is a state variable
          setExcel([]);
          getAllSimpanan(dispatch, {
            cari: "",
            page: page + 1,
            limit: totalPerHalaman,
            jenisUser: jenisUserFilter,
          });
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.error("Error submitting data:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mengirim data. Silakan coba lagi.",
        });
      });
  }

  function submitUpdateAllSimpanan(e) {
    e.preventDefault();

    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      showConfirmButton: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    if (tglUpdateSimpanan === "") {
      Swal.fire({
        title: "Tanggal Simpanan harus diisi !",
        icon: "warning",
      });
      return;
    }

    updateAllSimpanan({
      tglAkhir: tglUpdateSimpanan,
      tglSimpanan: tglUpdateSimpanan,
    })
      .then((response) => {
        Swal.close();
        if (response.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            // timer: 1500,
            showConfirmButton: true,
          });
          setModalUpdateSimpanan(false);
          getAllSimpanan(dispatch, {
            cari: "",
            page: page + 1,
            limit: totalPerHalaman,
            jenisUser: jenisUserFilter,
          });
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.error("Error submitting data:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mengirim data. Silakan coba lagi.",
        });
      });
  }

  const getExportErrorMessage = async (response, fallbackMessage) => {
    if (!response || !response.status || response.status === 200) {
      return null;
    }

    if (response.data instanceof Blob) {
      const text = await response.data.text();
      try {
        const parsed = JSON.parse(text);
        return parsed.message || fallbackMessage;
      } catch (error) {
        return text || fallbackMessage;
      }
    }

    return response.data && response.data.message
      ? response.data.message
      : fallbackMessage;
  };

  const submitExportAllSimpanan = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Konfirmasi Export Semua Simpanan",
      text: `Apakah Anda ingin mengexport semua simpanan ?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ya, Export",
      cancelButtonText: "Batal",
      allowOutsideClick: () => !Swal.isLoading(),
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const data = await exportAllSimpananExsist({});
          const errorMessage = await getExportErrorMessage(
            data,
            "Gagal export semua simpanan",
          );
          if (errorMessage) {
            throw new Error(errorMessage);
          }
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Export Semua Simpanan.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          Swal.fire({
            icon: "success",
            title: "Data berhasil diexport",
          });
        } catch (error) {
          Swal.fire({
            title: "Terjadi kesalahan",
            text: error.message,
            icon: "error",
          });
        }
      },
    });
  };

  const submitExportSimpananByDate = async (e) => {
    e.preventDefault();

    if (!exportTglMulai || !exportTglAkhir) {
      Swal.fire({
        title: "Bulan export harus diisi",
        text: "Pilih bulan mulai dan bulan sampai terlebih dahulu.",
        icon: "warning",
      });
      return;
    }

    if (moment(exportTglMulai).isAfter(moment(exportTglAkhir))) {
      Swal.fire({
        title: "Bulan tidak valid",
        text: "Bulan mulai tidak boleh lebih besar dari bulan sampai.",
        icon: "warning",
      });
      return;
    }

    Swal.fire({
      title: "Konfirmasi Export Simpanan",
      text: `Export data simpanan periode ${moment(exportTglMulai).format(
        "MMMM YYYY",
      )} sampai ${moment(exportTglAkhir).format("MMMM YYYY")} ?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ya, Export",
      cancelButtonText: "Batal",
      allowOutsideClick: () => !Swal.isLoading(),
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const data = await exportSimpananByDate({
            bulanMulai: exportTglMulai,
            bulanAkhir: exportTglAkhir,
          });
          const errorMessage = await getExportErrorMessage(
            data,
            "Gagal export data simpanan",
          );
          if (errorMessage) {
            throw new Error(errorMessage);
          }
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Export Simpanan ${exportTglMulai} sampai ${exportTglAkhir}.xlsx`,
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setModalExportSimpanan(false);
          setExportTglMulai("");
          setExportTglAkhir("");

          Swal.fire({
            icon: "success",
            title: "Data berhasil diexport",
          });
        } catch (error) {
          Swal.fire({
            title: "Terjadi kesalahan",
            text: error.message,
            icon: "error",
          });
        }
      },
    });
  };

  const downloadFile = (data, filename) => {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const submitDownloadTemplateHistorySimpanan = async () => {
    try {
      Swal.fire({
        title: "Menyiapkan template...",
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      const data = await downloadTemplateHistorySimpanan();
      Swal.close();
      downloadFile(data, "TemplateImportHistorySimpanan.xlsx");
    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: "Gagal download template histori simpanan.",
      });
    }
  };

  const submitImportHistorySimpanan = (e) => {
    e.preventDefault();

    if (excelHistorySimpanan.length === 0) {
      Swal.fire({
        title: "Pilih file terlebih dahulu",
        icon: "warning",
      });
      return;
    }

    const formData = new FormData();
    excelHistorySimpanan.forEach((file) => {
      formData.append("excelFile", file);
    });

    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      showConfirmButton: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    importHistorySimpanan(formData)
      .then((response) => {
        Swal.close();
        if (response.status === 200) {
          showImportHistorySimpananResult(response.data, "success");
          setModalImportHistorySimpanan(false);
          setExcelHistorySimpanan([]);
          getAllSimpanan(dispatch, {
            cari: searchText,
            page: page + 1,
            limit: totalPerHalaman,
            jenisUser: jenisUserFilter,
          });
        } else {
          if (response?.data?.gagal || response?.data?.sudahAda) {
            showImportHistorySimpananResult(response.data, "error");
          } else {
            Swal.fire({
              icon: "error",
              title: "Gagal",
              text:
                response?.data?.message ||
                "Terjadi kesalahan saat import histori simpanan.",
            });
          }
        }
      })
      .catch(() => {
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Terjadi kesalahan saat import histori simpanan.",
        });
      });
  };

  const submitGenerateWeeklyHistory = (e) => {
    e.preventDefault();

    if (!tglAkhirGenerateWeekly) {
      Swal.fire({
        title: "Tanggal akhir wajib diisi",
        text: "Pilih batas akhir generate histori simpanan mingguan.",
        icon: "warning",
      });
      return;
    }

    Swal.fire({
      title: "Konfirmasi Generate",
      text: `Generate simpanan mingguan dari join koperasi sampai ${moment(
        tglAkhirGenerateWeekly,
      ).format("DD MMMM YYYY")} ?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ya, Generate",
      cancelButtonText: "Batal",
      allowOutsideClick: () => !Swal.isLoading(),
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const response = await generateWeeklyHistorySimpanan({
          tglAkhir: tglAkhirGenerateWeekly,
        });

        if (!response || response.status !== 200) {
          throw new Error(
            response?.data?.message ||
              "Terjadi kesalahan saat generate histori simpanan mingguan.",
          );
        }

        return response.data;
      },
    })
      .then((result) => {
        if (!result.isConfirmed) return;
        showImportHistorySimpananResult(result.value, "success");
        setModalGenerateWeeklyHistory(false);
        setTglAkhirGenerateWeekly("");
        getAllSimpanan(dispatch, {
          cari: searchText,
          page: page + 1,
          limit: totalPerHalaman,
          jenisUser: jenisUserFilter,
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: error.message,
        });
      });
  };

  const handleDropdownItemDetail = (val) => {
    dispatch({ type: "SET_MODAL_SIMPANAN", data: false });
    setDetailUser(val);
    setKirimFcm(val.fcmTokenUser);
  };

  React.useEffect(() => {
    let tmp =
      simpanan.listSimpanan &&
      simpanan.listSimpanan.docs.map((val, index) => {
        return {
          ...val,
          action: (
            <div className="actions-right">
              <Dropdown drop="right">
                <Dropdown.Toggle
                  id="dropdown-basic"
                  style={{
                    backgroundColor: "#50A6C1",
                    border: 0,
                    fontWeight: "bold",
                  }}
                >
                  Aksi
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ zIndex: 1000, position: "relative" }}>
                  <Dropdown.Item
                    onClick={() => {
                      handleDropdownItemDetail(val);
                    }}
                  >
                    Detail
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              {/* <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Detail</Tooltip>}
              >
                <Button
                  className="mr-2"
                  variant="info"
                  style={{
                    marginTop: 5,
                    padding: "6px 15px",
                    fontSize: "18px",
                  }}
                  onClick={() => {
                    handleDetailClick(val);
                  }}
                >
                  <i class="fas fa-info"></i>
                </Button>
              </OverlayTrigger> */}
            </div>
          ),
        };
      });

    setListAllSimpanan(tmp);
  }, [simpanan]);

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const getStatusStyle = (status) => {
    switch (status) {
      case "Belum":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFE6E6",
          textColor: "#FF0000",
        };
      case "Sudah":
        return {
          fontWeight: "bold",
          backgroundColor: "#E6E6FF",
          textColor: "#0000FF",
        };
      default:
        return {};
    }
  };

  const getStatusResignStyle = (status) => {
    switch (status) {
      case "No":
        return {
          fontWeight: "bold",
          backgroundColor: "#E5F6FA",
          textColor: "#21ABCD",
        };
      case "Yes":
        return {
          fontWeight: "bold",
          backgroundColor: "#FF4040",
          textColor: "#FFECEC",
        };
      default:
        return {};
    }
  };

  const getStatusKoperasiStyle = (status) => {
    switch (status) {
      case "nonactive":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFE6E6",
          textColor: "#FF0000",
        };
      case "waiting":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFEEE6",
          textColor: "#FF4F00",
        };
      case "active":
        return {
          fontWeight: "bold",
          backgroundColor: "#E1FAEE",
          textColor: "#01D26D",
        };
      case "ex":
        return {
          fontWeight: "bold",
          backgroundColor: "#EA4335",
          textColor: "#FFFFFF",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    rows: {
      style: {
        height: 70, // override the row height
      },
    },
    table: {
      style: {
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
      },
    },
    headRow: {
      style: {
        minHeight: "56px",
        background: "linear-gradient(90deg, #7132CA, #7132CA)",
        borderBottom: "2px solid #e5e7eb",
      },
    },
    headCells: {
      style: {
        color: "#ffffff",
        minHeight: 50,
        fontWeight: "bold",
        fontSize: 14,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
    rows: {
      style: {
        minHeight: "50px",
        fontSize: "14px",
        color: "#374151",
        backgroundColor: "#ffffff",
        "&:not(:last-of-type)": {
          borderBottom: "1px solid #e5e7eb",
        },
      },
      stripedStyle: {
        backgroundColor: "#f9fafb",
      },
      highlightOnHoverStyle: {
        backgroundColor: "#eff6ff",
        cursor: "pointer",
        transition: "background-color 0.2s ease",
      },
    },

    cells: {
      style: {
        minHeight: 50,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
  };

  const colSimpanan = [
    {
      name: "No",
      width: "80px",
      center: true,
      // selector: (row) => getAllSimpanan.indexOf(row) + 1,
      selector: (row, index) => index + simpanan.listSimpanan.pagingCounter,
    },
    {
      name: "Nama",
      minWidth: "240px",
      center: true,
      sortable: true,
      selector: (row) => row.nama,
    },
    {
      name: "Nomor Pegawai",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nopeg,
    },
    {
      name: "Status Pegawai",
      minWidth: "200px",
      center: true,
      selector: (row) => row.statusResign,
      cell: (row) => {
        const statusStyle = getStatusResignStyle(row.statusResign);
        const tampilanLabel =
          row.statusResign === "No" ? "Aktif" : "Tidak Aktif";

        return (
          <div
            style={{
              fontWeight: statusStyle.fontWeight,
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {tampilanLabel}
          </div>
        );
      },
    },
    {
      name: "Tanggal Resign",
      minWidth: "200px",
      center: true,
      selector: (row) =>
        row.tglResign !== ""
          ? moment(row.tglResign).format("DD MMMM YYYY")
          : "-",
    },

    {
      name: "Status Koperasi",
      minWidth: "200px",
      center: true,
      selector: (row) =>
        row.statusKoperasi === "nonactive"
          ? "Tidak Aktif"
          : row.statusKoperasi === "waiting"
            ? "Menunggu"
            : row.statusKoperasi === "active"
              ? "Aktif"
              : row.statusKoperasi === "ex"
                ? "Keluar"
                : row.statusKoperasi,
      cell: (row) => {
        const statusKoperasi =
          row.statusKoperasi === "nonactive"
            ? "Tidak Aktif"
            : row.statusKoperasi === "waiting"
              ? "Menunggu"
              : row.statusKoperasi === "active"
                ? "Aktif"
                : row.statusKoperasi === "ex"
                  ? "Keluar"
                  : row.statusKoperasi;
        const statusStyle = getStatusKoperasiStyle(row.statusKoperasi);
        return (
          <div
            style={{
              fontWeight: statusStyle.fontWeight,
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {statusKoperasi}
          </div>
        );
      },
    },
    {
      name: "Join Koperasi",
      minWidth: "200px",
      center: true,
      selector: (row) =>
        !row.joinDate ? "-" : moment(row.joinDate).format("DD MMMM YYYY"),
    },
    {
      name: "Jenis User",
      minWidth: "160px",
      center: true,
      sortable: true,
      selector: (row) =>
        row.jenisUser === "mingguan" ? "Mingguan" : "Bulanan",
    },
    {
      name: "Perusahaan",
      minWidth: "200px",
      center: true,
      selector: (row) => row.namaPerusahaan,
    },
    {
      name: "Client",
      minWidth: "200px",
      center: true,
      selector: (row) => row.namaClient,
    },
    {
      name: "Cabang",
      minWidth: "200px",
      center: true,
      selector: (row) => row.namaCabang,
    },
    {
      name: "Limit Pengajuan",
      minWidth: "200px",
      center: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.limitPengajuan);
        return formattedValue;
      },
    },
    {
      name: "Nominal Simpanan Per Periode",
      minWidth: "270px",
      center: true,
      sortable: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.nominalSimpananPerBulan);
        return formattedValue;
      },
    },
    {
      name: "Total Simpanan",
      minWidth: "200px",
      center: true,
      sortable: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.total_simpanan);
        return formattedValue;
      },
    },
    {
      name: "Total Histori Simpanan",
      minWidth: "230px",
      center: true,
      selector: (row) => {
        return new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.total_simpanan_history || 0);
      },
    },
    {
      name: "Histori Soft Delete",
      minWidth: "190px",
      center: true,
      selector: (row) => row.count_simpanan_soft_delete || 0,
      cell: (row) => {
        const jumlah = row.count_simpanan_soft_delete || 0;
        return (
          <div
            style={{
              padding: "8px 10px",
              borderRadius: 6,
              fontWeight: 700,
              color: jumlah > 0 ? "#92400e" : "#166534",
              backgroundColor: jumlah > 0 ? "#fef3c7" : "#dcfce7",
            }}
          >
            {jumlah > 0 ? `${jumlah} histori` : "Tidak ada"}
          </div>
        );
      },
    },
    {
      name: "Tanggal Simpanan Terakhir",
      minWidth: "240px",
      center: true,
      sortable: true,
      selector: (row) => {
        const tglTerakhirSimpanan =
          row.list_simpanan.length > 0
            ? row.list_simpanan[0].tglSimpanan
              ? formatDateFull(row.list_simpanan[0].tglSimpanan)
              : "-"
            : "-";

        return tglTerakhirSimpanan;
      },
    },
    {
      name: "Periode Yang Harus Dibayar",
      minWidth: "250px",
      center: true,
      sortable: true,
      selector: (row) => formatPeriodeSimpanan(row),
    },
    {
      name: "Status Simpanan Periode Ini",
      minWidth: "240px",
      center: true,
      selector: (row) => row.status_pembayaran,
      cell: (row) => {
        const statusStyle = getStatusStyle(row.status_pembayaran);
        const tampilanLabel =
          row.status_pembayaran === "Belum" ? "Belum Terbayar" : "Terbayar";

        return (
          <div
            style={{
              fontWeight: statusStyle.fontWeight,
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {tampilanLabel}
          </div>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "200px",
      center: true,
      cell: (row) => row.action,
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.statusResign === "Yes",
      style: {
        backgroundColor: "#FFDBDB",
        color: "black",
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
    // {
    //   when: (row) => row.cancel === true && row.statusPengajuan === "Ditolak",
    //   style: {
    //     backgroundColor: "#FFFFFF",
    //     color: "black",
    //     "&:hover": {
    //       cursor: "pointer",
    //     },
    //   },
    // },
  ];

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handleCloseModalTambah = () => {
    setTglSimpanan("");
    setNominal("");
    setMultipleSelect("");
    setExcel([]);
  };

  const getUserAktif = (date) => {
    getUserAktifSimpanan(dispatch, date)
      .then((response) => {
        if (response && response.data) {
          const userAktifOptions = response.data.data.map((user) => ({
            value: user._id,
            label: `${user.nopeg} - ${user.nama}`,
            fcmToken: user.fcmToken,
          }));
          setUserAktifOptions(userAktifOptions);
        }
      })
      .catch((error) => {});
  };

  // const getStatusStyle = (status) => {
  //   switch (status) {
  //     case "Terbayar":
  //       return {
  //         fontWeight: "bold",
  //         backgroundColor: "#DBEFB5",
  //         textColor: "#87CB16",
  //       };
  //     case "Belum Terbayar":
  //       return {
  //         fontWeight: "bold",
  //         backgroundColor: "#FEBEC0",
  //         textColor: "#FB404B",
  //       };

  //     default:
  //       return {};
  //   }
  // };

  React.useEffect(() => {
    setIsLoading(true);
    getAllSimpanan(dispatch, {
      cari: searchText,
      page: page + 1,
      limit: totalPerHalaman,
      jenisUser: jenisUserFilter,
    })
      .then((response) => {
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [modalDetailSimpanan.modalDetailSimpanan, page, totalPerHalaman, jenisUserFilter]);

  React.useEffect(() => {
    setIsLoadingRekap(true);
    getRekapSimpananBulanan({
      page: 1,
      limit: 1000,
      bulan: rekapBulan,
      jenisUser: jenisUserFilter,
    })
      .then((response) => {
        if (response?.status === 200) {
          setRekapSimpanan(response.data.docs || []);
          setRekapTotal(response.data.totalNominal || 0);
          setRekapTotalHistory(response.data.totalNominalHistory || 0);
        } else {
          setRekapSimpanan([]);
          setRekapTotal(0);
          setRekapTotalHistory(0);
        }
      })
      .catch(() => {
        setRekapSimpanan([]);
        setRekapTotal(0);
        setRekapTotalHistory(0);
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Rekap simpanan bulanan gagal dimuat.",
        });
      })
      .finally(() => setIsLoadingRekap(false));
  }, [rekapBulan, jenisUserFilter]);

  const getRekapStatusStyle = (status) => {
    if (status === "Sudah Terbayar") {
      return { backgroundColor: "#dcfce7", color: "#166534" };
    }
    if (status === "Terbayar (Soft Delete)") {
      return { backgroundColor: "#fef3c7", color: "#92400e" };
    }
    if (status === "Tidak Ada Kewajiban") {
      return { backgroundColor: "#e0f2fe", color: "#075985" };
    }
    return { backgroundColor: "#fee2e2", color: "#991b1b" };
  };

  const formatNominalList = (nominals) => {
    if (!Array.isArray(nominals) || nominals.length === 0) return "-";
    return nominals
      .map((nominal) =>
        new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(nominal || 0),
      )
      .join(", ");
  };

  const colRekapSimpanan = [
    {
      name: "Nama",
      minWidth: "220px",
      sortable: true,
      selector: (row) => row.nama || "-",
    },
    {
      name: "Nomor Pegawai",
      minWidth: "170px",
      selector: (row) => row.nopeg || "-",
    },
    {
      name: "Jenis User",
      minWidth: "140px",
      center: true,
      selector: (row) => (row.jenisUser === "mingguan" ? "Mingguan" : "Bulanan"),
    },
    {
      name: "Status Pegawai",
      minWidth: "160px",
      center: true,
      cell: (row) => {
        const keluar = row.statusResign === "Yes";
        return (
          <div
            style={{
              padding: "8px 10px",
              borderRadius: 6,
              fontWeight: 700,
              color: keluar ? "#991b1b" : "#166534",
              backgroundColor: keluar ? "#fee2e2" : "#dcfce7",
            }}
          >
            {keluar ? "Karyawan Keluar" : "Aktif"}
          </div>
        );
      },
    },
    {
      name: "Periode",
      minWidth: "140px",
      center: true,
      selector: () => moment(rekapBulan, "YYYY-MM").format("MMMM YYYY"),
    },
    {
      name: "Terbayar Aktif / Wajib",
      minWidth: "150px",
      center: true,
      selector: (row) => `${row.jumlahTerbayar} / ${row.jumlahWajib}`,
    },
    {
      name: "Pernah Terbayar / Wajib",
      minWidth: "190px",
      center: true,
      selector: (row) => `${row.jumlahPernahTerbayar} / ${row.jumlahWajib}`,
    },
    {
      name: "Nominal Terbayar Aktif",
      minWidth: "300px",
      wrap: true,
      selector: (row) => formatNominalList(row.nominalTerbayar),
    },
    {
      name: "Nominal Pernah Terbayar",
      minWidth: "300px",
      wrap: true,
      selector: (row) => formatNominalList(row.nominalPernahTerbayar),
    },
    {
      name: "Nominal Histori Soft Delete",
      minWidth: "300px",
      wrap: true,
      selector: (row) => formatNominalList(row.nominalSoftDelete),
    },
    {
      name: "Nominal Simpanan Bulan Ini",
      minWidth: "230px",
      center: true,
      selector: (row) =>
        new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.totalNominalHistory || 0),
    },
    {
      name: "Histori Soft Delete",
      minWidth: "170px",
      center: true,
      selector: (row) => `${row.jumlahSoftDelete || 0} / ${row.jumlahWajib}`,
    },
    {
      name: "Status Simpanan",
      minWidth: "220px",
      center: true,
      cell: (row) => {
        const style = getRekapStatusStyle(row.statusPembayaran);
        return (
          <div
            style={{
              ...style,
              padding: "8px 10px",
              borderRadius: 6,
              fontWeight: 700,
              whiteSpace: "nowrap",
            }}
          >
            {row.statusPembayaran}
          </div>
        );
      },
    },
    {
      name: "Keterangan",
      minWidth: "300px",
      selector: (row) => row.keterangan || "-",
    },
  ];

  return (
    <>
      {modalDetailSimpanan.modalDetailSimpanan ? (
        <>
          <Container fluid>
            <Row>
              <Col md="12">
                <Card>
                  <Card.Header>
                    <Card.Title
                      as="h3"
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                      }}
                    >
                      list simpanan
                      <hr></hr>
                    </Card.Title>

                    <Tab.Content>
                      <Card
                        style={{
                          border: 0,
                          marginTop: 20,
                          // backgroundColor: "red",
                        }}
                      >
                        <Row
                          style={{
                            display: "flex",
                            marginTop: 15,
                            // justifyContent: "space-between",
                          }}
                        >
                          {auth.role === "super admin" ||
                          auth.role === "admin" ? (
                            <Col
                              md={"12"}
                              className="d-flex flex-wrap align-items-center"
                              style={{ gap: 10 }}
                            >
                              <Button
                                style={{
                                  fontWeight: "bold",
                                  border: 0,
                                  backgroundColor: "#A2CFFE",
                                  color: "black",
                                  height: 40,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  margin: 0,
                                }}
                                className="btn-wd"
                                onClick={() => {
                                  // setIdUser(val.idUser);
                                  setModalTambahSimpanan(true);
                                }}
                              >
                                Tambah Simpanan
                              </Button>
                              <Button
                                className="btn-wd"
                                onClick={() => setModalUpdateSimpanan(true)}
                                style={{
                                  backgroundColor: "#887191",
                                  color: "#171F04",
                                  border: 0,
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  height: 40,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  margin: 0,
                                }}
	                              >
	                                Update All Simpanan
	                              </Button>
	                              <Button
	                                className="btn-wd"
	                                onClick={() => setModalImportHistorySimpanan(true)}
	                                style={{
	                                  backgroundColor: "#E8F0C8",
	                                  color: "#3E4A04",
	                                  border: 0,
	                                  fontWeight: "bold",
	                                  cursor: "pointer",
	                                  height: 40,
	                                  display: "inline-flex",
	                                  alignItems: "center",
	                                  justifyContent: "center",
	                                  margin: 0,
	                                }}
		                              >
		                                Import Histori Simpanan
		                              </Button>
		                              <Button
		                                className="btn-wd"
		                                onClick={() => setModalGenerateWeeklyHistory(true)}
		                                style={{
		                                  backgroundColor: "#D9F7E7",
		                                  color: "#0F5132",
		                                  border: 0,
		                                  fontWeight: "bold",
		                                  cursor: "pointer",
		                                  height: 40,
		                                  display: "inline-flex",
		                                  alignItems: "center",
		                                  justifyContent: "center",
		                                  margin: 0,
		                                }}
		                              >
		                                Generate Histori Mingguan
		                              </Button>
		                              {/* <Button
                                style={{
                                  fontWeight: "bold",
                                  backgroundColor: "#887191",
                                  border: 0,
                                }}
                                className="btn-wd ml-2"
                                onClick={() => {
                                  // setIdUser(val.idUser);
                                  setModalUpdateSimpanan(true);
                                }}
                              >
                                Update All Simpanan
                              </Button> */}

                              <Button
                                onClick={submitExportAllSimpanan}
                                style={{
                                  backgroundColor: "#DDDCD9",
                                  color: "#54534D",
                                  border: 0,
                                  fontWeight: "bold",
                                  height: 40,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  margin: 0,
                                }}
                                className="btn-wd"
                              >
                                Export All Simpanan
                              </Button>
                              <Button
                                onClick={() => {
                                  setModalExportSimpanan(true);
                                }}
                                style={{
                                  backgroundColor: "#DDDCD9",
                                  color: "#54534D",
                                  border: 0,
                                  fontWeight: "bold",
                                  height: 40,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  margin: 0,
                                }}
                                className="btn-wd"
                              >
                                Export Simpanan By Date
                              </Button>
                            </Col>
                          ) : null}
                        </Row>
                      </Card>
                    </Tab.Content>
                  </Card.Header>
                  <Col
                    md={"12"}
                    className="d-flex flex-wrap justify-content-end align-items-center"
                    style={{ padding: 0, gap: 10, marginTop: 14 }}
                  >
                    <div style={{ minWidth: 210 }}>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        value={
                          [
                            { value: "", label: "Semua Jenis User" },
                            { value: "mingguan", label: "User Mingguan" },
                            { value: "bulanan", label: "User Bulanan" },
                          ].find((option) => option.value === jenisUserFilter)
                        }
                        onChange={(option) => {
                          setJenisUserFilter(option?.value || "");
                          setPage(0);
                        }}
                        options={[
                          { value: "", label: "Semua Jenis User" },
                          { value: "mingguan", label: "User Mingguan" },
                          { value: "bulanan", label: "User Bulanan" },
                        ]}
                        placeholder="Filter jenis user"
                      />
                    </div>
                    <Col>
                      <InputGroup>
                        <Form.Control
                          style={{
                            paddingLeft: "10px",
                          }}
                          type="text"
                          value={searchText}
                          onChange={handleSearch}
                          onKeyPress={handleKeyPress}
                          placeholder="Nama/Nopeg"
                        />
                        <InputGroup.Append>
                          <InputGroup.Text
                            style={{ cursor: "pointer" }}
                            onClick={handleClearSearch}
                          >
                            <i className="fas fa-times"></i>
                          </InputGroup.Text>
                        </InputGroup.Append>
                      </InputGroup>
                    </Col>

                    <Button
                      style={{
                        fontSize: 16,
                        backgroundColor: "#00BFFF",
                        border: 0,
                        paddingTop: 10,
                        paddingBottom: 7,
                      }}
                      onClick={handleFilterChange}
                    >
                      <i className="fas fa-search"></i>
                    </Button>
                  </Col>
                  <Card.Body>
                    {isLoading ? (
                      <div
                        className="loader-container"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          height: "30vh",
                        }}
                      >
                        <Dna
                          visible={true}
                          height="80"
                          width="80"
                          ariaLabel="dna-loading"
                          wrapperStyle={{}}
                          wrapperClass="dna-wrapper"
                        />
                        <p>Loading...</p>
                      </div>
                    ) : (
                      <div>
                        {listAllSimpanan.length > 0 ? (
                          <DataTable
                            columns={colSimpanan}
                            data={listAllSimpanan}
                            customStyles={customStyles}
                            paginationPerPage={totalPerHalaman}
                            progressPending={isLoading}
                            conditionalRowStyles={conditionalRowStyles}
                          />
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <p
                              style={{
                                fontWeight: "bold",
                                marginBottom: "1rem",
                              }}
                            >
                              Maaf, belum ada simpanan saat ini.
                            </p>
                            <img
                              src={require("assets/img/sorry.jpg").default}
                              alt="Sorry"
                              style={{
                                maxWidth: "20%",
                                display: "block",
                                margin: "0 auto",
                              }}
                            />
                          </div>
                        )}

                        <div style={{ marginTop: 35 }}>
                          <Row
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Col>
                              <Row style={{ alignItems: "center" }}>
                                <div
                                  style={{
                                    paddingRight: 0,
                                    marginLeft: 20,
                                    marginRight: 10,
                                  }}
                                >
                                  <label style={{ fontWeight: "bold" }}>
                                    Rows per page
                                  </label>
                                </div>
                                <Col sm="3" style={{ paddingLeft: 0 }}>
                                  <Select
                                    className="react-select primary"
                                    classNamePrefix="react-select"
                                    name="Pilih Client"
                                    value={options.find(
                                      (option) =>
                                        option.value === totalPerHalaman,
                                    )}
                                    onChange={handlePageSizeChange}
                                    options={options}
                                    placeholder="Rows per page"
                                  />
                                </Col>
                              </Row>
                            </Col>

                            <Col>
                              <ReactPaginate
                                forcePage={page}
                                containerClassName="paginations justify-content-end"
                                previousClassName="pages-items-containers"
                                previousLinkClassName="pages-links-labels"
                                nextClassName="pages-items-containers"
                                nextLinkClassName="pages-links-labels"
                                breakClassName="pages-items-containers"
                                pageCount={simpanan.listSimpanan.totalPages}
                                pageRangeDisplayed={3}
                                marginPagesDisplayed={1}
                                pageLinkClassName="pages-links-labels"
                                pageClassName="pages-items-containers"
                                activeClassName="actives"
                                activeLinkClassName="activess"
                                nextLabel=" > "
                                previousLabel=" < "
                                initialPage={page}
                                disableInitialCallback={true}
                                onPageChange={(val) => {
                                  setPage(val.selected);
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>

          <Container fluid style={{ marginTop: 20 }}>
            <Card>
              <Card.Header>
                <Card.Title as="h4" style={{ fontWeight: "bold", margin: 0 }}>
                  Rekap Simpanan Per Bulan
                </Card.Title>
                <div style={{ color: "#64748b", marginTop: 6 }}>
                  Menampilkan user yang memiliki record simpanan pada bulan terpilih,
                  termasuk histori yang berstatus soft delete.
                </div>
              </Card.Header>
              <Card.Body>
                <Row className="align-items-end" style={{ marginBottom: 18 }}>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Bulan</Form.Label>
                      <Form.Control
                        type="month"
                        value={rekapBulan}
                        onChange={(event) => setRekapBulan(event.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Jenis User</Form.Label>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        value={[
                          { value: "", label: "Semua Jenis User" },
                          { value: "mingguan", label: "User Mingguan" },
                          { value: "bulanan", label: "User Bulanan" },
                        ].find((option) => option.value === jenisUserFilter)}
                        onChange={(option) => setJenisUserFilter(option?.value || "")}
                        options={[
                          { value: "", label: "Semua Jenis User" },
                          { value: "mingguan", label: "User Mingguan" },
                          { value: "bulanan", label: "User Bulanan" },
                        ]}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <div
                      style={{
                        padding: "10px 14px",
                        borderRadius: 8,
                        backgroundColor: "#eff6ff",
                        color: "#1e3a8a",
                        fontWeight: 800,
                        minHeight: 42,
                      }}
                    >
                      Total Simpanan Bulan Ini: {new Intl.NumberFormat("id-ID", {
                        style: "currency",
                        currency: "IDR",
                        minimumFractionDigits: 0,
                      }).format(rekapTotalHistory)}
                      {rekapTotalHistory !== rekapTotal ? (
                        <small style={{ display: "block", fontWeight: 600 }}>
                          Aktif: {new Intl.NumberFormat("id-ID", {
                            style: "currency",
                            currency: "IDR",
                            minimumFractionDigits: 0,
                          }).format(rekapTotal)}
                        </small>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                {isLoadingRekap ? (
                  <div style={{ textAlign: "center", padding: 30 }}>
                    <Dna visible height="70" width="70" ariaLabel="rekap-loading" />
                    <p>Memuat rekap...</p>
                  </div>
                ) : (
                  <DataTable
                    columns={colRekapSimpanan}
                    data={rekapSimpanan}
                    customStyles={customStyles}
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 15, 30, 50, 75, 100]}
                    noDataComponent="Belum ada data simpanan pada periode ini."
                  />
                )}
              </Card.Body>
            </Card>
          </Container>

          <Modal
            size="lg"
            show={modalTambahSimpanan}
            onHide={() => {
              handleCloseModalTambah();
              setModalTambahSimpanan(false);
            }}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <Row>
                <Col md="12">
                  <Form action="" className="form" method="">
                    <Card>
                      <Card.Header>
                        <Card.Header>
                          <Card.Title as="h4" style={{ fontWeight: "bold" }}>
                            Tambah Simpanan
                          </Card.Title>
                        </Card.Header>
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col sm="12">
                            <Form.Group>
                              <label
                                style={{
                                  fontWeight: "bold",
                                  fontSize: 14,
                                  color: "grey",
                                  textTransform: "none",
                                }}
                              >
                                Tanggal Simpanan
                              </label>
                              <Form.Control
                                onChange={(e) => {
                                  setTglSimpanan(e.target.value);
                                  getUserAktif(e.target.value);
                                }}
                                type="date"
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col md="12">
                            <Row style={{ alignItems: "center" }}>
                              <Form.Text
                                // className="text-muted"
                                style={{
                                  color: "blue",
                                  fontWeight: "bold",
                                  marginLeft: 10,
                                }}
                              >
                                *Download format unggah simpanan
                              </Form.Text>
                              <Button
                                style={{
                                  margin: 10,
                                  padding: 5,
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  window.open(
                                    "https://docs.google.com/spreadsheets/d/12tTcCcz4HGRQ-vK28h0HmmjOEH99ukqM/edit?usp=sharing&ouid=115920084350641374457&rtpof=true&sd=true",
                                    "_blank",
                                  );
                                }}
                              >
                                Download
                                <i
                                  class="fas fa-download"
                                  style={{ marginLeft: 5 }}
                                ></i>
                              </Button>
                            </Row>
                            <label
                              className="label-input-file btn text-white mb-4"
                              htmlFor="import2"
                              style={{
                                fontWeight: "bold",
                                backgroundColor: "#12E193",
                                border: 0,
                              }}
                            >
                              <div
                                style={{
                                  color: "#02160F",
                                }}
                              >
                                Pilih File
                              </div>

                              <input
                                type="file"
                                id="import2"
                                onClick={(e) => {
                                  e.target.value = "";
                                }}
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                                accept=".xls,.xlsx"
                                multiple
                              />
                            </label>
                            {excel.map((file, index) => (
                              <div
                                className="d-flex align-items-center"
                                key={index}
                              >
                                <p className="mb-1 mr-1">{file.name}</p>
                                <button
                                  onClick={() => removeExcel(index)}
                                  className="btn btn-link remove text-danger"
                                >
                                  <i className="fa fa-times" />
                                </button>
                              </div>
                            ))}

                            {/* <Form.Control
                              type="file"
                              accept=".xls,.xlsx"
                              onChange={(e) => {
                                setExcel(e.target.files[0]);
                              }}
                            ></Form.Control> */}
                          </Col>

                          {/* <Col sm="12">
                            <Form.Group>
                              <label
                                style={{
                                  fontWeight: "bold",
                                  fontSize: 14,
                                  color: "grey",
                                  textTransform: "none",
                                }}
                              >
                                Nominal
                              </label>
                              <p>
                                <CurrencyInput
                                  style={{
                                    padding: 5,
                                    borderRadius: 4,
                                    width: "100%",
                                    height: "40px",
                                    borderWidth: "1px",
                                    borderTopColor: "rgba(227, 227, 227, 0.3)",
                                    borderLeftColor: "rgba(227, 227, 227, 0.3)",
                                    borderBottomColor: "rgba(227, 227, 227, 1)",
                                    borderRightColor: "rgba(227, 227, 227, 1)",
                                  }}
                                  name="nominal"
                                  placeholder="Masukkan nominal"
                                  prefix="Rp "
                                  groupSeparator="."
                                  decimalSeparator=","
                                  onValueChange={(value) => {
                                    setNominal(value);
                                  }}
                                />
                              </p>
                            </Form.Group>
                          </Col>
                          <Col sm="12">
                            <Form.Group>
                              <label
                                style={{
                                  fontWeight: "bold",
                                  fontSize: 14,
                                  color: "grey",
                                  textTransform: "none",
                                }}
                              >
                                Nama
                              </label>
                              <div>
                                <Select
                                  className="react-select info"
                                  classNamePrefix="react-select"
                                  placeholder="Pilih Nopeg / Nama"
                                  name="multipleSelect"
                                  closeMenuOnSelect={false}
                                  isMulti
                                  // value={multipleSelect}
                                  // onChange={(value) =>  setMultipleSelect(value)}
                                  onChange={(value) => {
                                    setMultipleSelect(value);
                                  }}
                                  options={[
                                    {
                                      value: "",
                                      label: "Pilih Nopeg / Nama",
                                      isDisabled: true,
                                    },
                                    ...userAktifOptions,
                                  ]}
                                />
                              </div>
                            </Form.Group>
                          </Col> */}
                        </Row>

                        <div className="clearfix"></div>
                      </Card.Body>
                    </Card>
                    <div style={{ marginTop: 30, textAlign: "end" }}>
                      <Button
                        className="btn-fill pull-right"
                        type="submit"
                        // variant="info"
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#A2CFFE",
                          border: 0,
                          color: "black",
                        }}
                        onClick={submitTambahSimpanan}
                      >
                        Submit
                      </Button>
                    </div>
                  </Form>
	                </Col>
	              </Row>
	            </Modal.Body>
	          </Modal>
	          <Modal
	            size="md"
	            show={modalImportHistorySimpanan}
	            onHide={() => {
	              setExcelHistorySimpanan([]);
	              setModalImportHistorySimpanan(false);
	            }}
	            aria-labelledby="import-history-simpanan-modal"
	          >
	            <Modal.Header closeButton></Modal.Header>
	            <Modal.Body>
	              <Row>
	                <Col md="12">
	                  <Form action="" className="form" method="">
	                    <Card>
	                      <Card.Header>
	                        <Card.Title
	                          as="h4"
	                          style={{ fontWeight: "bold", textAlign: "center" }}
	                        >
	                          Import Histori Simpanan
	                          <hr></hr>
	                        </Card.Title>
	                      </Card.Header>
	                      <Card.Body>
	                        <Row>
	                          <Col md="12">
	                            <Button
	                              className="btn-wd mb-3"
	                              onClick={submitDownloadTemplateHistorySimpanan}
	                              style={{
	                                backgroundColor: "#DDDCD9",
	                                color: "#54534D",
	                                border: 0,
	                                fontWeight: "bold",
	                              }}
	                            >
	                              Download Template
	                            </Button>
	                            <br />
	                            <label
	                              className="label-input-file btn text-white mb-4"
	                              htmlFor="import-history-simpanan"
	                              style={{
	                                fontWeight: "bold",
	                                backgroundColor: "#12E193",
	                                border: 0,
	                              }}
	                            >
	                              <div style={{ color: "#02160F" }}>Pilih File</div>
	                              <input
	                                type="file"
	                                id="import-history-simpanan"
	                                onClick={(e) => {
	                                  e.target.value = "";
	                                }}
	                                onChange={handleHistorySimpananFileChange}
	                                style={{ display: "none" }}
	                                accept=".xls,.xlsx"
	                              />
	                            </label>
	                            {excelHistorySimpanan.map((file, index) => (
	                              <div
	                                className="d-flex align-items-center"
	                                key={index}
	                              >
	                                <p className="mb-1 mr-1">{file.name}</p>
	                                <button
	                                  onClick={() => removeHistorySimpananExcel(index)}
	                                  className="btn btn-link remove text-danger"
	                                >
	                                  <i className="fa fa-times" />
	                                </button>
	                              </div>
	                            ))}
	                          </Col>
	                        </Row>
	                      </Card.Body>
	                    </Card>
	                    <div style={{ marginTop: 30, textAlign: "end" }}>
	                      <Button
	                        className="btn-fill pull-right"
	                        type="submit"
	                        style={{
	                          fontWeight: "bold",
	                          backgroundColor: "#A2CFFE",
	                          border: 0,
	                          color: "black",
	                        }}
	                        onClick={submitImportHistorySimpanan}
	                      >
	                        Submit
	                      </Button>
	                    </div>
	                  </Form>
	                </Col>
		              </Row>
		            </Modal.Body>
		          </Modal>
		          <Modal
		            size="md"
		            show={modalGenerateWeeklyHistory}
		            onHide={() => {
		              setTglAkhirGenerateWeekly("");
		              setModalGenerateWeeklyHistory(false);
		            }}
		            aria-labelledby="generate-weekly-history-simpanan-modal"
		          >
		            <Modal.Header closeButton></Modal.Header>
		            <Modal.Body>
		              <Row>
		                <Col md="12">
		                  <Form action="" className="form" method="">
		                    <Card>
		                      <Card.Header>
		                        <Card.Title
		                          as="h4"
		                          style={{ fontWeight: "bold", textAlign: "center" }}
		                        >
		                          Generate Histori Simpanan Mingguan
		                          <hr></hr>
		                        </Card.Title>
		                      </Card.Header>
		                      <Card.Body>
		                        <Row>
		                          <Col sm="12">
		                            <Form.Group>
		                              <label
		                                style={{
		                                  fontWeight: "bold",
		                                  fontSize: 14,
		                                  color: "grey",
		                                  textTransform: "none",
		                                }}
		                              >
		                                Tanggal Akhir
		                              </label>
		                              <Form.Control
		                                value={tglAkhirGenerateWeekly}
		                                onChange={(e) => {
		                                  setTglAkhirGenerateWeekly(e.target.value);
		                                }}
		                                type="date"
		                              ></Form.Control>
		                              <small style={{ color: "#6c757d" }}>
		                                Sistem akan membuat simpanan tiap Jumat mulai
		                                Jumat minggu berikutnya dari tanggal join koperasi
		                                user mingguan sampai tanggal ini.
		                              </small>
		                            </Form.Group>
		                          </Col>
		                        </Row>
		                      </Card.Body>
		                    </Card>
		                    <div style={{ marginTop: 30, textAlign: "end" }}>
		                      <Button
		                        variant="secondary"
		                        style={{
		                          fontWeight: "bold",
		                          border: 0,
		                          marginRight: 10,
		                        }}
		                        onClick={() => {
		                          setTglAkhirGenerateWeekly("");
		                          setModalGenerateWeeklyHistory(false);
		                        }}
		                      >
		                        Batal
		                      </Button>
		                      <Button
		                        className="btn-fill pull-right"
		                        type="submit"
		                        style={{
		                          fontWeight: "bold",
		                          backgroundColor: "#A2CFFE",
		                          border: 0,
		                          color: "black",
		                        }}
		                        onClick={submitGenerateWeeklyHistory}
		                      >
		                        Generate
		                      </Button>
		                    </div>
		                  </Form>
		                </Col>
		              </Row>
		            </Modal.Body>
		          </Modal>
		          <Modal
		            size="md"
		            show={modalExportSimpanan}
            onHide={() => {
              setExportTglMulai("");
              setExportTglAkhir("");
              setModalExportSimpanan(false);
            }}
            aria-labelledby="export-simpanan-modal"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <Row>
                <Col md="12">
                  <Form action="" className="form" method="">
                    <Card>
                      <Card.Header>
                        <Card.Title
                          as="h4"
                          style={{ fontWeight: "bold", textAlign: "center" }}
                        >
                          Export Simpanan By Date
                          <hr></hr>
                        </Card.Title>
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col sm="6">
                            <Form.Group>
                              <label
                                style={{
                                  fontWeight: "bold",
                                  fontSize: 14,
                                  color: "grey",
                                  textTransform: "none",
                                }}
                              >
                                Bulan Mulai
                              </label>
                              <Form.Control
                                value={exportTglMulai}
                                onChange={(e) => {
                                  setExportTglMulai(e.target.value);
                                }}
                                type="month"
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                          <Col sm="6">
                            <Form.Group>
                              <label
                                style={{
                                  fontWeight: "bold",
                                  fontSize: 14,
                                  color: "grey",
                                  textTransform: "none",
                                }}
                              >
                                Bulan Sampai
                              </label>
                              <Form.Control
                                value={exportTglAkhir}
                                min={exportTglMulai || undefined}
                                onChange={(e) => {
                                  setExportTglAkhir(e.target.value);
                                }}
                                type="month"
                              ></Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <div style={{ marginTop: 30, textAlign: "end" }}>
                      <Button
                        variant="secondary"
                        style={{
                          fontWeight: "bold",
                          border: 0,
                          marginRight: 10,
                        }}
                        onClick={() => {
                          setExportTglMulai("");
                          setExportTglAkhir("");
                          setModalExportSimpanan(false);
                        }}
                      >
                        Batal
                      </Button>
                      <Button
                        className="btn-fill pull-right"
                        type="submit"
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#A2CFFE",
                          border: 0,
                          color: "black",
                        }}
                        onClick={submitExportSimpananByDate}
                      >
                        Export
                      </Button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
          <Modal
            size="md"
            show={modalUpdateSimpanan}
            onHide={() => {
              handleCloseModalTambah();
              setModalUpdateSimpanan(false);
            }}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <Row>
                <Col md="12">
                  <Form action="" className="form" method="">
                    <Card>
                      <Card.Header>
                        <Card.Header>
                          <Card.Title
                            as="h4"
                            style={{ fontWeight: "bold", textAlign: "center" }}
                          >
                            Update All Simpanan
                            <hr></hr>
                          </Card.Title>
                        </Card.Header>
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col sm="6">
                            <Form.Group>
                              <label
                                style={{
                                  fontWeight: "bold",
                                  fontSize: 14,
                                  color: "grey",
                                  textTransform: "none",
                                }}
                              >
	                                Tanggal Simpanan
                              </label>
                              <Form.Control
	                                onChange={(e) => {
	                                  setTglUpdateSimpanan(e.target.value);
	                                  // getUserAktif(e.target.value);
	                                }}
	                                type="date"
	                              ></Form.Control>
	                              <small style={{ color: "#6c757d" }}>
	                                Pilih hari Jumat untuk proses user mingguan atau tanggal 28 untuk user bulanan.
	                              </small>
                            </Form.Group>
                          </Col>
                        </Row>

                        <div className="clearfix"></div>
                      </Card.Body>
                    </Card>
                    <div style={{ marginTop: 30, textAlign: "end" }}>
                      <Button
                        className="btn-fill pull-right"
                        type="submit"
                        // variant="info"
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#A2CFFE",
                          border: 0,
                          color: "black",
                        }}
                        onClick={submitUpdateAllSimpanan}
                      >
                        Submit
                      </Button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        </>
      ) : (
        <>
          <DetailSimpanan detailSimpanan={detailUser} dataFcmToken={kirimFcm} />
        </>
      )}
    </>
  );
}

export default Simpanan;
